export const TABS = [
  { label: 'All', value: 'all' },
  { label: 'Approved to share', value: 'approved_to_share' },
  { label: 'My Library', value: 'my_library' },
];
